import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import { SpecSnapshot } from './types';

export * from './types';

export const getSpecSnapshotApi = (params: { showAll?: boolean } = {}) =>
  apiClient.get<SpecSnapshot>('/v2/snapshot/specs', { params });

export const fetchSpecSnapshotApi = () =>
  fetchClient.fetch<SpecSnapshot>('/v2/snapshot/specs', {
    params: { showAll: 'true' },
    next: { tags: ['fetchSpecSnapshotApi'], revalidate: 300 },
  });
